/**
 * Same-origin guard for operator-supplied URL overrides (e.g. `?audioUrl=`
 * in `./main`): resolves `v` against `base` and only accepts it when the
 * resolved origin matches `base`'s — otherwise a query string could point
 * `ScareScene` at third-party remote media, which the content boundary
 * (original assets only) forbids.
 *
 * Split out of `./main` (which unconditionally calls `boot()` at module
 * load, so importing it directly isn't safe outside a real DOM) into its
 * own side-effect-free module, same pattern as `./face/gaze` vs.
 * `./face/landmarker` — pure logic testable without a browser.
 */
export function sameOriginUrl(v: string, base: string): string | null {
  try {
    const resolved = new URL(v, base);
    return resolved.origin === new URL(base).origin ? v : null;
  } catch {
    return null;
  }
}
